import { Component, Input, Output, EventEmitter } from "@angular/core";
import { NzTreeNode } from "ng-zorro-antd/tree";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";

@Component({
  selector: "app-system-menu",
  templateUrl: "./system-menu.component.html",
  styleUrls: ["./system-menu.component.scss"],
})
export class SystemMenuComponent {
  @Input() data;
  @Input() searchedValue = "";
  @Input() isLoading: boolean = false;
  @Input() selectedSystemData;
  @Output() onItemClick: EventEmitter<any> = new EventEmitter();

  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };
  expandKey = [];
  defaultKey = [];
  compsTableId;

  ngOnChanges(changes) {
    if (
      changes.selectedSystemData &&
      changes.selectedSystemData.currentValue !==
        changes.selectedSystemData.previousValue
    ) {
      const levelOneId = this.selectedSystemData.level_one_id;
      const levelTwoId = this.selectedSystemData.level_two_id;
      this.compsTableId = this.selectedSystemData.id;
      (this.expandKey = [`sector_${levelOneId}`, `industry_${levelTwoId}`]),
        (this.defaultKey = [`vacomp_${this.compsTableId}`]);
    }
  }

  handleMenuOnclick(data) {
    if (data instanceof NzTreeNode) {
      data.isExpanded = !data.isExpanded;
    } else {
      const node = data.node;
      if (node) {
        node.isExpanded = !node.isExpanded;
      }
    }
    const isThirdLevel = data.node.level === 2;
    if (isThirdLevel) {
      this.compsTableId = data.node.origin.data_key;
      const result = {
        id: this.compsTableId,
        levelTwoId: data.node.parentNode.origin.data_key,
        levelOneId: data.node.parentNode.parentNode.origin.data_key,
      };
      this.onItemClick.emit(result);
    }
  }
}
